import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'

import './index.scss'

import App from './App'
import { hashUserId, setGaUser } from './analytics'

import * as serviceWorker from './serviceWorker'

const GA_MEASUREMENT_ID = 'G-4F1HKH4CJ6'

// Seed hashed user_id on initial load so the first page_view is attributed.
try {
    const storedUser = window.localStorage.getItem('user')
    if (storedUser) {
        const parsed = JSON.parse(storedUser)
        if (parsed && parsed.username) {
            hashUserId(parsed.username).then((hashed) => setGaUser(GA_MEASUREMENT_ID, hashed))
        }
    }
} catch (e) { /* ignore */ }

const trackPageView = (location) => {
    if (typeof window.gtag !== 'function') return
    const path = (location.basename || '') + location.pathname + (location.search || '')
    window.gtag('event', 'page_view', {
        page_path: path,
        page_location: window.location.origin + path,
        page_title: document.title,
    })
}

const history = createBrowserHistory()
history.listen((location) => trackPageView(location))
trackPageView(history.location)


ReactDOM.render((
    <Router history={history}>
        <App gaId={GA_MEASUREMENT_ID} history={history} />
    </Router>
), document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
